import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

import { theme } from "@huub-web/ui/theme/css/theme.css";

export const imageStyle = style({
  width: rem(100),
  height: rem(100),
  flexShrink: 0,
  objectFit: "cover",
  borderRadius: theme.borderRadiuses.s,
  "@container": {
    "container (max-width: 500px)": {
      width: rem(64),
      height: rem(64),
    },
  },
});

export const contentStyle = style({
  gap: theme.spacings.m,
  alignItems: "flex-start",
  paddingTop: 0,
  paddingBottom: 0,
  "@container": {
    "container (max-width: 500px)": {
      paddingLeft: 0,
      paddingRight: 0,
      gap: theme.spacings.s,
    },
  },
});
